import React from "react";

export default function ChartAxes({
    width,
    height,
    left,
    top,
    bottom,
    yTicks,
    xLabels,
    xPositions,
    compact = false,
}) {
    const usableHeight = height - top - bottom;
    const maxTick = Math.max(1, ...yTicks);

    return (
        <g>
            {/* Horizontal grid lines for depth */}
            {yTicks.map((tick) => {
                const y = top + (1 - tick / maxTick) * usableHeight;
                return (
                    <line
                        key={`grid-${tick}`}
                        x1={left}
                        y1={y}
                        x2={width}
                        y2={y}
                        stroke="rgba(148, 163, 184, 0.12)"
                        strokeWidth="0.5"
                        strokeDasharray="3 3"
                    />
                );
            })}

            {/* Axes */}
            <line
                x1={left}
                y1={top}
                x2={left}
                y2={height - bottom}
                stroke="rgba(148, 163, 184, 0.25)"
                strokeWidth="0.75"
            />
            <line
                x1={left}
                y1={height - bottom}
                x2={width}
                y2={height - bottom}
                stroke="rgba(148, 163, 184, 0.25)"
                strokeWidth="0.75"
            />

            {/* Y-axis ticks */}
            {yTicks.map((tick) => {
                const y = top + (1 - tick / maxTick) * usableHeight;
                return (
                    <g key={`y-${tick}`}>
                        <line
                            x1={left - 3}
                            y1={y}
                            x2={left}
                            y2={y}
                            stroke="rgba(148, 163, 184, 0.35)"
                            strokeWidth="0.75"
                        />
                        <text
                            x={0}
                            y={y + 3}
                            fontSize="6.5"
                            fill="rgba(107, 114, 128, 0.7)"
                            fontFamily="'Inter', sans-serif"
                            fontWeight="500"
                        >
                            {tick}
                        </text>
                    </g>
                );
            })}

            {/* X-axis ticks */}
            {xLabels.map((label, index) => {
                if (compact && index % 2 !== 0) return null;
                const x = xPositions[index] ?? left;
                return (
                    <text
                        key={`x-${label}`}
                        x={x}
                        y={height}
                        fontSize="6.5"
                        fill="rgba(107, 114, 128, 0.7)"
                        textAnchor="middle"
                        fontFamily="'Inter', sans-serif"
                        fontWeight="500"
                        letterSpacing="-0.01em"
                    >
                        {label}
                    </text>
                );
            })}
        </g>
    );
}
